import React from 'react'
import { mount } from 'enzyme'
import loan from './testData/loan'
import EntityTabs from '../EntityTabs'
import EntityTab from '../EntityTab'

describe('<EntityTabs />', () => {
  const entities = loan.businesses.concat(loan.businesses.reduce((acc, b) => acc.concat(b.guarantors), []))
  const noop = () => {}
  it('renders without crashing', () => {
    mount(<EntityTabs entities={entities} onChange={noop} value={0} />)
  })
  it('should have the same number of tabs as there are entities', () => {
    const wrapper = mount(<EntityTabs entities={entities} onChange={noop} value={0} />)
    expect(wrapper.find(EntityTab)).toHaveLength(entities.length + 2)
  })
  it('should have its onChange handler called with the index of the clicked entity as the argument', () => {
    const onChangeMock = jest.fn()
    const wrapper = mount(<EntityTabs entities={entities} onChange={onChangeMock} value={0} />)
    const secondTab = wrapper.find(EntityTab).at(1)
    secondTab.simulate('click')
    expect(onChangeMock.mock.calls.length).toEqual(1)
    expect(onChangeMock.mock.calls[0][0]).toEqual(1) // Check first argument of first function call
  })
  it('should display "Bank Statement" text', () => {
    const wrapper = mount(
      <EntityTabs
        entities={entities}
        onChange={() => {}}
        value={0}
      />
    );
    expect(wrapper.text()).toContain("Bank Statement");
  });
})
